import { API_CONFIG } from 'config/api';

const WALLET_BASE_URL = API_CONFIG.WALLET.BASE_URL;

export interface WalletResponse {
  success: boolean;
  data?: any;
  message?: string;
}

export interface WalletStatistics {
  totalWallets: number;
  totalBalance: number;
  activeWallets: number;
  averageBalance: number;
  balanceByCurrency: Record<string, number>;
  walletGrowth: Array<{
    month: string;
    count: number;
    balance: number;
  }>;
}

export class WalletApiService {
  private getAuthHeaders() {
    const token = localStorage.getItem('vpd_auth_token') || sessionStorage.getItem('vpd_auth_token');
    return {
      'Content-Type': 'application/json',
      'Authorization': token ? `Bearer ${token}` : '',
    };
  }

  async getWallets(country: string = 'NG', currency: string = 'NGN'): Promise<WalletResponse> {
    try {
      const queryParams = new URLSearchParams();
      if (country) queryParams.append('country', country);
      if (currency) queryParams.append('currency', currency);

      const response = await fetch(`${WALLET_BASE_URL}${API_CONFIG.WALLET.ENDPOINTS.WALLETS}?${queryParams}`, {
        method: 'GET',
        headers: this.getAuthHeaders(),
      });

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Get wallets API error:', error);
      throw new Error('Failed to fetch wallets');
    }
  }

  async getWalletStatistics(): Promise<WalletResponse> {
    try {
      const response = await fetch(`${WALLET_BASE_URL}${API_CONFIG.WALLET.ENDPOINTS.STATISTICS}`, {
        method: 'GET',
        headers: this.getAuthHeaders(),
      });

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Get wallet statistics API error:', error);
      throw new Error('Failed to fetch wallet statistics');
    }
  }

  async getTransactions(filters: {
    page?: number;
    limit?: number;
    type?: string;
    status?: string;
    startDate?: string;
    endDate?: string;
  } = {}): Promise<WalletResponse> {
    try {
      const queryParams = new URLSearchParams();
      
      if (filters.page) queryParams.append('page', filters.page.toString());
      if (filters.limit) queryParams.append('limit', filters.limit.toString());
      if (filters.type) queryParams.append('type', filters.type);
      if (filters.status) queryParams.append('status', filters.status);
      if (filters.startDate) queryParams.append('startDate', filters.startDate);
      if (filters.endDate) queryParams.append('endDate', filters.endDate);

      const response = await fetch(`${WALLET_BASE_URL}${API_CONFIG.WALLET.ENDPOINTS.TRANSACTIONS}?${queryParams}`, {
        method: 'GET',
        headers: this.getAuthHeaders(),
      });

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Get wallet transactions API error:', error);
      throw new Error('Failed to fetch wallet transactions');
    }
  }

  async getEmployeeWallet(employeeId: string): Promise<WalletResponse> {
    try {
      const response = await fetch(`${WALLET_BASE_URL}${API_CONFIG.WALLET.ENDPOINTS.WALLETS}/${employeeId}`, {
        method: 'GET',
        headers: this.getAuthHeaders(),
      });

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Get employee wallet API error:', error);
      throw new Error('Failed to fetch employee wallet');
    }
  }
}

export const walletApiService = new WalletApiService();
